/**
 * checkBreach — HaveIBeenPwned k-anonymous Pwned Passwords lookup.
 *
 * The password NEVER leaves the browser. We hash it (SHA-1) locally, send
 * only the first 5 hex chars to `api.pwnedpasswords.com/range/{prefix}`,
 * and match the returned list against the remaining 35 chars locally.
 *
 * Returns `{ count: 0 }` when the password is not in any known breach,
 * `{ count: N }` when it is, or `{ count: null, error }` on network fail
 * (we NEVER block signup on API errors — HIBP is best-effort).
 */
export async function checkBreach(password) {
  if (!password) return { count: 0 };
  try {
    const hash = await sha1Hex(password);
    const prefix = hash.slice(0, 5).toUpperCase();
    const suffix = hash.slice(5).toUpperCase();
    const res = await fetch(`https://api.pwnedpasswords.com/range/${prefix}`, {
      headers: { "Add-Padding": "true" },
    });
    if (!res.ok) return { count: null, error: `HTTP ${res.status}` };
    const body = await res.text();
    for (const line of body.split("\n")) {
      const [hashSuffix, countStr] = line.trim().split(":");
      if (hashSuffix === suffix) {
        const n = parseInt(countStr, 10);
        return { count: Number.isFinite(n) ? n : 0 };
      }
    }
    return { count: 0 };
  } catch (err) {
    return { count: null, error: String(err) };
  }
}

async function sha1Hex(text) {
  const buf = new TextEncoder().encode(text);
  const digest = await crypto.subtle.digest("SHA-1", buf);
  return [...new Uint8Array(digest)].map(b => b.toString(16).padStart(2, "0")).join("");
}
